import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import s from './PromtBlocks.module.css';
import Button from '../../../../shared/ui/button/Button';
import { useAppDispatch } from '../../../../store/store';
import {
    selectSelectedImage,
    // selectTemporaryImage,
} from '../../../../store/selectors/imageSelectors';
import {
    // clearTemporaryImage,
    setLoadingSave,
    // setTemporaryImage,
} from '../../../../store/slices/imageSlice';
import {
    enhanceImageUrl,
    resetImageUrl,
    updateImage,
} from '../../../../shared/api/imageProjectApi';
import { toast } from 'react-toastify';
const EnhanceBlock: React.FC = () => {
    const dispatch = useAppDispatch();
    const selectedImage = useSelector(selectSelectedImage);

    const [isEnhancing, setIsEnhancing] = useState(false);

    if (!selectedImage?.image) return <p className={s.text}>No image selected</p>;

    const handleEnhance = async () => {
        setIsEnhancing(true);

        try {
            console.log('Enhancing image...');
            if (selectedImage?.image?.id) {
                await dispatch(enhanceImageUrl({ imageId: selectedImage?.image?.id }));
            }

            setTimeout(() => {
                setIsEnhancing(false);
            }, 2000);
            toast.success('Image enhanced successfully');
        } catch (error: any) {
            console.error('Failed to enhance image:', error);
            toast.error(error?.message || 'Failed to enhance image');
            setIsEnhancing(false);
        }
    };

    const handleCancel = async () => {
        dispatch(setLoadingSave(true));
        if (selectedImage?.image?.id) {
            await dispatch(resetImageUrl({ imageId: selectedImage?.image?.id }));
        }
        dispatch(setLoadingSave(false));
    };

    return (
        <div className={s.container}>
            <div className={s.block_container}>
                <p className={s.text}>Would you like our AI to enhance your Image?</p>

                <div
                    style={{
                        display: 'flex',
                        gap: '10px',
                        justifyContent: 'center',
                        marginTop: '20px',
                    }}
                >
                    <Button
                        text="Reset Image"
                        onClick={handleCancel}
                        state="enabled"
                        style={{
                            backgroundColor: '#f5f5f5',
                            color: '#333',
                            border: '1px solid #ddd',
                            borderRadius: '6px',
                            width: '100px',
                            height: '32px',
                            fontSize: '12px',
                            whiteSpace: 'nowrap',
                        }}
                    />
                    <Button
                        text={isEnhancing ? 'Enhancing...' : 'AI Enhance'}
                        onClick={handleEnhance}
                        state={isEnhancing ? 'loading' : 'enabled'}
                        style={{
                            backgroundColor: '#FFDD35',
                            color: '#000',
                            borderRadius: '6px',
                            width: '120px',
                            height: '32px',
                            fontSize: '12px',
                            whiteSpace: 'nowrap',
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

export default EnhanceBlock;
